module.exports = __webpack_public_path__ + "6c77a9e7a99cff2355532bc6ffe770b0.MP3";